import React from 'react';
import Radium from 'radium';
import Animate from 'rc-animate';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { actions as passwordActions } from './redux/modules/password';
import Card from './components/Card';
import ErrorMessage from './components/messages/ErrorMessage';
import Notice from './components/Notice';
import StyleDecorator from './components/StyleDecorator';
import PasswordInput from './components/inputs/PasswordInput';
import Button from './components/buttons/Button';
import LandingPageLink from './components/links/LandingPageLink';
import translate from './locale/translate';
import SipgateFormHeaderLogo from './components/images/SipgateFormHeaderLogo';
import { paths } from './routes/index';

const mapStateToProps = (state, ownProps) => ({
	nonce: ownProps.params.nonce,
	passwordChanged: state.password.passwordChanged,
	fetching: state.password.fetching,
	passwordChangeFailed: state.password.passwordChangeFailed,
});

export class ChangePasswordApp extends React.Component {
	static propTypes = {
		nonce: React.PropTypes.string.isRequired,
		changePassword: React.PropTypes.func.isRequired,
		passwordChanged: React.PropTypes.bool.isRequired,
		passwordChangeFailed: React.PropTypes.bool.isRequired,
		fetching: React.PropTypes.bool.isRequired,
	};

	state = {
		errorMessage: null,
	};

	handleSubmit = (e) => {
		e.preventDefault();

		this.setState({
			errorMessage: null,
		});
		const { newPassword, newPasswordRepeat } = e.target.elements;

		if (newPassword.value.length < 8) {
			this.setState({
				errorMessage: translate('ERROR_PASSWORD_LENGTH'),
			});
			newPassword.focus();
			return;
		}

		if (newPassword.value !== newPasswordRepeat.value) {
			this.setState({
				errorMessage: translate('ERROR_PASSWORD_MISMATCH'),
			});
			newPassword.focus();
			return;
		}

		this.props.changePassword(this.props.nonce, newPassword.value, newPasswordRepeat.value);
	};

	getStyle() {
		return {
			form: {
				width: '100%',
			},
			forgotPasswordLink: {
				transform: 'scale(0.75)',
				display: 'inline-block',
				transformOrigin: 'right',
			},
			forgotPasswordContainer: {
				textAlign: 'right',
			},
			button: {
				marginTop: '35px',
			},
		};
	}

	resetPasswordForm(style) {
		let errorMessage = this.state.errorMessage;
		if (this.props.passwordChangeFailed) {
			errorMessage = translate('PASSWORD_CHANGE_FAILED_MESSAGE');
		}
		const message = (errorMessage)
			? (
				<Animate
					transitionName={'alert'}
					transitionAppear
				>
					<ErrorMessage text={errorMessage} />
				</Animate>
			)
			: null;

		const footer = (
			<div>
				<Button
					type={'submit'}
					style={style.button}
					disabled={this.props.fetching}
				>
					{translate('BUTTON_SAVE_NEW_PASSWORD')}
				</Button>
				<LandingPageLink />
			</div>
		);
		return (
			<Card
				header={<SipgateFormHeaderLogo />}
				footer={footer}
				preBody={message}
			>
				<PasswordInput
					name={'newPassword'}
					placeholder={translate('FORM_LABEL_NEW_PASSWORD')}
				/>
				<PasswordInput
					name={'newPasswordRepeat'}
					placeholder={translate('FORM_LABEL_PASSWORD_REPEAT')}
				/>
			</Card>
		);
	}

	submitNotice(style) {
		return (
			<Card
				header={<SipgateFormHeaderLogo />}
				footer={<LandingPageLink />}
			>
				<Notice>
					<h3>{translate('NOTICE_PASSWORD_CHANGE_SUCCESS_HEADER')}</h3>
					<p>{translate('NOTICE_PASSWORD_CHANGE_SUCCESS')}</p>
					<Button
						style={style.button}
						onTouchTap={() => browserHistory.push(paths.APP_ROOT)}
					>
						{translate('LABEL_NAVIGATE_TO_LOGIN')}
					</Button>
				</Notice>
			</Card>
		);
	}

	render() {
		const style = this.getStyle();
		const content = this.props.passwordChanged
			? this.submitNotice(style)
			: this.resetPasswordForm(style);
		return (
			<form
				className={'flex-container'}
				onSubmit={this.handleSubmit}
				style={style.form}
				noValidate
			>
				{content}
			</form>
		);
	}
}

export default connect(mapStateToProps, { ...passwordActions })(StyleDecorator(Radium(ChangePasswordApp)));



// WEBPACK FOOTER //
// ./src/ChangePasswordApp.js